import {Alert, Button, Col, Row, Spin, Tabs} from "antd";
import {FullPageLoader} from "../../../../components/full-page-loader";
import {StyledPageHeader} from "../../../../styles/dashboard/calls/calls";
import {useCustomerUpcomingEvents} from "../../../../features/customer-live-events";
import {UpcomingClassesCustomer} from "../../../../components/live-classes/upcoming-classes/customer/upcoming-classes";
import {CustomerPastLiveClasses} from "../../../../components/live-classes/past-classes/customer";
import {CustomerDashboardWrapper} from "../../../../layouts/customer-dashboard-wrapper";
import {LoadingSpinner} from "../../../../components/icons/icons";
import {useState} from "react";
import {CustomPagination} from "../../../../components/pagination";
import {ErrorBoundary} from "react-error-boundary";

function CustomerLiveClassesPage() {
  const [currentLiveClassPage, setCurrentLiveClassPage] = useState(1);
  const perPage = 5;
  const getLiveClassesQuery = useCustomerUpcomingEvents({
    page: currentLiveClassPage,
    perPage,
  });
  const pageTitle = "Live events";

  const liveEvents = getLiveClassesQuery.data?.data ?? [];
  const paginationMeta = getLiveClassesQuery.data
    ? {
        current_page: currentLiveClassPage,
        per_page: perPage,
        total_pages: Math.ceil(getLiveClassesQuery.data.total / perPage),
        next_page: getLiveClassesQuery.data.hasNextPage ? currentLiveClassPage + 1 : 0,
        previous_page: getLiveClassesQuery.data.hasPrevPage
          ? currentLiveClassPage - 1
          : 0,
      }
    : undefined;

  if (getLiveClassesQuery.isLoading) {
    return (
      <CustomerDashboardWrapper pageTitle={pageTitle}>
        <StyledPageHeader>Live events</StyledPageHeader>
        <FullPageLoader />
      </CustomerDashboardWrapper>
    );
  }

  if (
    getLiveClassesQuery.isError &&
    getLiveClassesQuery.error.message !==
      "Sorry, You currently do not have any live events!"
  ) {
    return (
      <CustomerDashboardWrapper pageTitle={pageTitle}>
        <StyledPageHeader>Live events</StyledPageHeader>
        <Alert
          message="Error"
          description={getLiveClassesQuery.error.message}
          type="error"
          showIcon
        />
      </CustomerDashboardWrapper>
    );
  }
  return (
    <CustomerDashboardWrapper pageTitle={pageTitle}>
      <StyledPageHeader>Live events</StyledPageHeader>
      <div style={{marginTop: "1.5rem"}}>
        <Row gutter={[36, 30]}>
          <Col span={24} lg={{span: 16}}>
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="Upcoming events" key="1">
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <Spin
                    spinning={getLiveClassesQuery.isFetching}
                    tip="Updating..."
                    indicator={LoadingSpinner}
                  >
                    <UpcomingClassesCustomer events={liveEvents} />
                    {liveEvents.length > 0 && (
                      <CustomPagination
                        isPreviousData={getLiveClassesQuery.isPreviousData}
                        page={currentLiveClassPage}
                        paginationMeta={paginationMeta}
                        setPage={setCurrentLiveClassPage}
                      />
                    )}
                  </Spin>
                </ErrorBoundary>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Past events" key="2">
                <ErrorBoundary
                  FallbackComponent={({error, resetErrorBoundary}) => (
                    <div>
                      <Alert
                        message="Sorry, something went wrong."
                        showIcon
                        description={error.message}
                        type="error"
                        action={
                          <Button
                            onClick={() => {
                              resetErrorBoundary();
                            }}
                            size="small"
                            danger
                          >
                            Reset
                          </Button>
                        }
                      />
                    </div>
                  )}
                >
                  <CustomerPastLiveClasses />
                </ErrorBoundary>
              </Tabs.TabPane>
            </Tabs>
          </Col>
          <Col span={24} lg={{span: 8}}></Col>
        </Row>
      </div>
    </CustomerDashboardWrapper>
  );
}

export {CustomerLiveClassesPage};
